import isEmpty from "lodash-es/isEmpty";

const HandleEmptyField = ({ text }) => {
  return <span>{isEmpty(text) ? "-- NONE --" : text}</span>;
};

export default HandleEmptyField;
